import React from 'react'
import {
  Button,
  Popup
} from 'semantic-ui-react'
// Local
import {
  CONDITION,
  shouldRenderReskin2025
} from '../../../constant'
import { EncounterConditionDisplay } from '../../authenticated/types'
import ReveleerButton from '../../common/ReveleerButton'
import If from '../../common/if'

type Props = {
  condition: EncounterConditionDisplay
  onClick: (
    action: keyof typeof CONDITION.ACTION,
    condition: EncounterConditionDisplay | string
  ) => void
}

function ConditionDismissButton(
  props: Props
) {
  const {
    condition,
    onClick
  } = props
  const onClickFn = () => {
    if (condition.conditionCode === CONDITION.CODE.DISMISSED) {
      onClick(
        CONDITION.ACTION.MARK_OPEN,
        condition
      )
    } else {
      onClick(
        CONDITION.ACTION.MARK_DISMISSED,
        condition
      )
    }
  }

  if (condition.conditionCode === CONDITION.CODE.DISMISSED) {
    return (
      <span>
        <span className="italic">
          Marked as Dismissed by Provider
        </span>
        <span>&nbsp;|&nbsp;</span>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerButton
            buttonLabel="Undo"
            buttonSize="small"
            buttonType="dismissive"
            id="condition-dismiss-undo-button"
            isDisabled={ false }
            onClick={ onClickFn }
            type="button"
          />
        </If>
        <If isTrue={ !shouldRenderReskin2025 }>
          <span
            className="linkable"
            onClick={ onClickFn }
          >
            Undo
          </span>
        </If>
      </span>
    )
  }
  return (
    <Popup
      content="Mark as Dismissed"
      mouseEnterDelay={ 1000 }
      trigger={
        shouldRenderReskin2025
          ? (
            <ReveleerButton
              buttonLabel="Dismiss"
              buttonSize="small"
              buttonType="secondary"
              id="condition-dismiss"
              isDisabled={ false }
              onClick={ onClickFn }
              type="button"
            />
          )
          : (
            <Button
              id="condition-dismiss"
              onClick={ onClickFn }
            >
              Dismiss
            </Button>
          )
      }
    />
  )
}

export default ConditionDismissButton
